import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Notification } from 'yurstrap';
import { removeNotification } from '../../services/Notifications';

import NotificationBulk from './NotificationsBulk';

const propTypes = {
    NotificationsActions: PropTypes.shape({
        removeNotification: PropTypes.func.isRequired,
    }).isRequired,
    notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
    withI18N: PropTypes.bool,
};

const defaultProps = {
    withI18N: false,
};

export class NotificationsList extends Component {

    renderNotifications() {
        const {
            notifications,
            withI18N,
        } = this.props;
        const notificationsBulkNames = _.uniq(_.pluck(notifications, 'bulkName'));
        return _.map(notificationsBulkNames, (bulkName) => (
            <NotificationBulk
                key={bulkName}
                bulkName={bulkName}
                withI18N={withI18N}
            />
        ));
    }

    render() {
        return (
            <div>
                <Notification className="u-theme--dark">
                    {this.renderNotifications()}
                </Notification>
            </div>
        );
    }

}

NotificationsList.propTypes = propTypes;

NotificationsList.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        notifications: state.Notifications.notifications,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        NotificationsActions: bindActionCreators({
            removeNotification,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
